import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  calculateTimeDefault(time)
  {
    if(time > 0) {
      // let minutes = Math.round(time / 60);
      // let seconds =
      // minutes = Math.round(minutes * 100) / 100;
      // return minutes + " lac";

      var days = Math.floor(time / 86400);
      time -= days * 86400;

      // calculate (and subtract) whole hours
      var hours = Math.floor(time / 3600) % 24;
      time -= hours * 3600;
      // calculate (and subtract) whole minutes
      var minutes = Math.floor(time / 60) % 60;
      time -= minutes * 60;
      // what's left is seconds
      var seconds = Math.floor(time % 60);  // in theory the modulus is not required

      if(days > 0)
        return ` ${days} <small>D</small> ${hours} <small>H</small> ${minutes} <small>M</small> ${seconds} <small>S</small>`;
      else if(hours > 0)
        return ` ${hours} <small>H</small> ${minutes} <small>M</small> ${seconds} <small>S</small>`;
      else
        return ` ${minutes} <small>M</small> ${seconds} <small>S</small>`;
      // return `${days} DD ${hours} Hrs ${minutes} Mins ${seconds} sec`;
    }
    return "";
  }

  calculateTimeSimple(time)
  {
    if(time > 0) {
      var days = Math.floor(time / 86400);
      time -= days * 86400;
      var hours = Math.floor(time / 3600) % 24;
      time -= hours * 3600;
      // calculate (and subtract) whole minutes
      var minutes = Math.ceil(time / 60) % 60;
      let returnString = "";
      if(days > 0)
        returnString += days == 1 ? days + " day and " : days + " days and ";
      if(hours > 0 || days > 0)
        returnString += hours == 1 ? hours + " hour and " : hours + " hours and ";
        returnString += minutes == 1 ?  minutes + " minute" : minutes + " minutes";
       return returnString;
      // time -= minutes * 60;
      // // what's left is seconds
      // var seconds = Math.floor(time % 60);  // in theory the modulus is not required
      // return `${hours} <small>H</small> ${minutes} <small>M</small> ${seconds} <small>S</small>`;
      // return `${days} DD ${hours} Hrs ${minutes} Mins ${seconds} sec`;
    }
    return "";
  }

  transform(time, format = 'Default') {
    switch (format) {
      case 'Default':
        return this.calculateTimeDefault(time);
        break;
      case 'Simple':
        return this.calculateTimeSimple(time);
        break;
    }
  }

}
